import React, { useState, useContext } from "react";
import "./register.css";
import api, { API_URL, AuthContext, showAlert } from "./util/api";
import { Link, useNavigate } from "react-router-dom";

export default function Register() {

    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    const [form, setForm] = useState({
        name: "",
        email: "",
        phone: "",
        gender: "",
        password: "",
        confirm_password: "",
        reg_pin: "",
        dob_day: "",
        dob_month: ""
    });

    const [picture, setPicture] = useState(null);
    const [preview, setPreview] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0);

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const MAX_WIDTH = 1920;
    const MAX_HEIGHT = 1080;
    const QUALITY = 0.8;

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const resizeImage = (file) => {
        return new Promise((resolve) => {
            const img = new Image();
            const reader = new FileReader();

            reader.onload = (e) => {
                img.src = e.target.result;
            };

            img.onload = () => {
                let width = img.width;
                let height = img.height;

                if (width > MAX_WIDTH || height > MAX_HEIGHT) {
                    const ratio = Math.min(MAX_WIDTH / width, MAX_HEIGHT / height);
                    width = width * ratio;
                    height = height * ratio;
                }

                const canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;

                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, width, height);

                canvas.toBlob(
                    (blob) => {
                        const newFile = new File([blob], file.name, {
                            type: "image/jpeg",
                        });
                        resolve(newFile);
                    },
                    "image/jpeg",
                    QUALITY
                );
            };

            reader.readAsDataURL(file);
        });
    };

    const handlePictureChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (!file.type.startsWith("image/")) {
            showAlert("error", "Invalid File", "Only image files are allowed!", 4000);
            e.target.value = "";
            return;
        }

        try {
            const resizedImage = await resizeImage(file);

            setPicture(resizedImage);
            setPreview(URL.createObjectURL(resizedImage));

        } catch (error) {
            showAlert("error", "Image Error", "Failed to process image, please change the image", 4000);
        }
    };

    const submitForm = async (e) => {
        e.preventDefault();

        if (form.password !== form.confirm_password) {
            showAlert("error", "Password Error", "Passwords do not match!", 4000);
            return;
        }

        try {
            const formData = new FormData();
            setLoading(true);

            Object.keys(form).forEach(key => formData.append(key, form[key]));

            if (picture) {
                formData.append("picture", picture);
            }

            let response = await api.post(`${API_URL}/register`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
                onUploadProgress: (progressEvent) => {
                    const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setUploadProgress(percent);
                }
            });

            if (response.data.success === true) {
                showAlert(
                    "success",
                    "Registration Successful!",
                    "Your registration was successful.",
                    5000
                );

                setPicture(null);
                setPreview(null);
                setUploadProgress(0);

                login(response.data.token, response.data.data);

                navigate("/dashboard");

            } else {
                showAlert("error", "Registration Failed", response.data.message, 5000);
            }

            setLoading(false);

        } catch (e) {
            showAlert("error", "Registration Failed", `Your registration failed. Please try again later. ${e.message}`, 5000);
            setUploadProgress(0);
            setLoading(false);
        }
    };

    return (
        <div className="conference-page">
            <section id="register" className="register-section">
                <div className="register-box">
                    <h2 style={{ color: "white" }}>Register</h2>

                    <form onSubmit={submitForm}>

                        <input
                            type="text"
                            name="name"
                            placeholder="Full Name"
                            value={form.name}
                            onChange={handleChange}
                            required
                        />

                        <input
                            type="email"
                            name="email"
                            placeholder="Email Address"
                            value={form.email}
                            onChange={handleChange}
                            required
                        />

                        <input
                            type="text"
                            name="phone"
                            placeholder="Phone Number"
                            value={form.phone}
                            onChange={handleChange}
                            required
                        />

                        <select
                            name="gender"
                            value={form.gender}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Select Gender</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                        </select>

                        {/* DOB */}
                        <label align="left">Date of Birth</label>
                        <div style={{ display: "flex", gap: "10px" }}>
                            <select name="dob_day" value={form.dob_day} onChange={handleChange} required>
                                <option value="">Day</option>
                                {[...Array(31)].map((_, i) => (
                                    <option key={i + 1} value={i + 1}>{i + 1}</option>
                                ))}
                            </select>

                            <select name="dob_month" value={form.dob_month} onChange={handleChange} required>
                                <option value="">Month</option>
                                {[
                                    "January", "February", "March", "April", "May", "June",
                                    "July", "August", "September", "October", "November", "December"
                                ].map((month, i) => (
                                    <option key={i + 1} value={i + 1}>{month}</option>
                                ))}
                            </select>
                        </div>

                         <label  align="left">  Enter Your Pasword  </label>

                        {/* PASSWORD */}
                        <div style={{ position: "relative" }}>
                            <input
                                type={showPassword ? "text" : "password"}
                                name="password"
                                placeholder="Password"
                                value={form.password}
                                onChange={handleChange}
                                required
                            />
                            <span onClick={() => setShowPassword(!showPassword)}
                                style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", cursor: "pointer", fontSize: 12, color: "#fff" }}>
                                {showPassword ? "Hide" : "Show"}
                            </span>
                        </div>

                         <label  align="left">  Confirm Your Pasword  </label>

                        {/* CONFIRM PASSWORD */}
                        <div style={{ position: "relative" }}>
                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                name="confirm_password"
                                placeholder="Confirm Password"
                                value={form.confirm_password}
                                onChange={handleChange}
                                required
                            />
                            <span onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", cursor: "pointer", fontSize: 12, color: "#fff" }}>
                                {showConfirmPassword ? "Hide" : "Show"}
                            </span>
                        </div>

                        <label align="left">Registration Pin (Contact Admin)</label>

                        <input
                            type="text"
                            name="reg_pin"
                            placeholder="Registration Pin"
                            value={form.reg_pin}
                            onChange={handleChange}
                            required
                        />


                        <label  align="left">  Upload  Your Picture   </label>

                        {/* IMAGE */}
                        <input type="file" accept="image/*" onChange={handlePictureChange} />

                        {preview && (
                            <img src={preview} alt="Preview"
                                style={{ width: 100, height: 100, borderRadius: "50%", marginTop: 8 }} />
                        )}

                        {uploadProgress > 0 && (
                            <div>
                                <div style={{ height: 8, background: "#ddd" }}>
                                    <div style={{ width: `${uploadProgress}%`, height: "100%", background: "#4caf50" }} />
                                </div>
                                {uploadProgress}%
                            </div>
                        )}

                        <button disabled={loading} type="submit">
                            {loading ? "Registering..." : "Register Now"}
                        </button>

                    </form>

                    <p>You already have an account? <Link style={{ color: "white" }} to="/login">Login here</Link></p>
                </div>
            </section>
        </div>
    );
}